import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { first } from 'rxjs/operators';
import { HistoryLog } from '../../models';
import { environment } from '../../../environments/environment';

const tableWithHistory: Array<{label: string, model: string}> = [
  {
    label: 'dashboard.common.ticket',
    model: 'Ticket',
  },
  {
    label: 'dashboard.historyFields.saleRecord',
    model: 'SaleRecord',
  },
  {
    label: 'dashboard.historyFields.event',
    model: 'Event',
  },
  {
    label: 'dashboard.historyFields.personnalisation',
    model: 'EventPersonalization',

  },
  {
    label: 'dashboard.historyFields.ticketingPlatforms',
    model: 'TicketingPlatform',
  },
  {
    label: 'dashboard.historyFields.ticketTemplate',
    model: 'TicketTemplate',
  },
  {
    label: 'dashboard.common.categories',
    model: 'Category',
  },
  {
    label: 'dashboard.historyFields.waitListConfig',
    model: 'WaitListConfig',
  },
  {
    label: 'dashboard.historyFields.automation',
    model: 'Automation',
  },
  {
    label: 'dashboard.common.ticket',
    model: 'Organizer',
  },
  {
    label: 'dashboard.historyFields.eventOrganizer',
    model: 'EventOrganizer',
  },
  {
    label: 'dashboard.historyFields.waitlistRegistration',
    model: 'WaitList',
  },
  {
    label: 'dashboard.historyFields.automaticPurchase',
    model: 'WaitListPurchase',
  },
  {
    label: 'dashboard.historyFields.categoriesGroup',
    model: 'CategoriesGroup',
  },
  {
    label: 'dashboard.common.users',
    model: 'UserInfo',
  },
  {
    label: 'dashboard.historyFields.userPaymentProvider',
    model: 'UserPaymentProvider',
  },
];
const tableList = (tableWithHistory.map( (t) => t.model));
type TableWithHistory = typeof tableList[number];

@Injectable({
  providedIn: 'root',
})
export class HistoryLogService {
  private http = inject(HttpClient);

  private configUrl = environment.apiUrl;
  public tableWithHistory = tableWithHistory;

  /**
   * @param eventId is required for backend guard when calling organizer ressource
   */
  getHistoryLog<T>(tableRowId: number, tableName: TableWithHistory, eventId: number) {
    const route = `${this.configUrl}h/l/${tableName}/${tableRowId}/${eventId}`;
    return this.http.get<{history: Array<HistoryLog<T>>; row: T}>(route).pipe(
      first(),
    );
  }

}
